export const CSS = {
  container: "container",
};

export const TOOLTIP_OPEN_DELAY_MS = 300;
export const TOOLTIP_CLOSE_DELAY_MS = 500;

export const ARIA_DESCRIBED_BY = "aria-describedby";
